module.exports = __webpack_public_path__ + "img/Realisme_Tida_og_samfunnsforholdene3.1450363a.jpg";